import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split',
})
export class SplitPipe implements PipeTransform {
  transform(value: string): string {
    const splitByTilde = '~'; //gahr-1242, separator changed for proper link text
    let finalWebsite: string;
    let websiteArr: string[] = [];

    if (value) {
      const splittedText = value.split(splitByTilde);
      splittedText.forEach((e: string) => {
        let websiteVar: string[] = e.split(/ (.*)/);
        let label = websiteVar[1] === '' ? websiteVar[0] : websiteVar[1];
        finalWebsite =
          '<a href="' + websiteVar[0] + '" target="_blank" class="gah__link">' + label + '</a>';
        websiteArr.push(finalWebsite);
      });
      return websiteArr.join('<br />');
    }
  }
}
